import {Injectable} from '@angular/core';
import {Config, STYLE } from '../model/config';

export const DefaultConfig: Config = {
  allowSearch: true,
  searchEnabled: false,
  headerEnabled: true,
  orderEnabled: true,
  orderEventOnly: false,
  paginationEnabled: true,
  clickEvent: true,
  selectRow: false,
  selectCol: false,
  selectCell: false,
  rows: 25,
  additionalActions: false,
  serverPagination: true,
  isLoading: false,
  detailsTemplate: false,
  groupRows: false,
  paginationRangeEnabled: true,
  collapseAllRows: false,
  checkboxes: false,
  radio: false,
  resizeColumn: true,
  fixedColumnWidth: false,
  horizontalScroll: false,
  logger: false,
  showDetailsArrow: false,
  showContextMenu: false,
  paginationMaxSize: 13,
  threeWaySort: false,
  onDragOver: false,
  tableLayout: {
    style: STYLE.TINY,
    borderless: true,
    hover: false,
    striped: false,
  },
};

@Injectable()
export class DefaultConfigService {
  public static readonly config: Config = DefaultConfig;
}
